<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total products"
                                type="gradient-red"
                                :sub-title="products.length"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="In Stock"
                                type="gradient-orange"
                                :sub-title="inStock.length"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Out of Stock"
                                type="gradient-green"
                                :sub-title="outOfStock.length"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Disabled"
                                type="gradient-info"
                                :sub-title="disabled.length"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="font-weight-bold text-primary">All Products</h4>
                                </div>
                            </div>
                        </div>
                        <div class=" table-responsive no-padding">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="products"
                                    :pagination-options="{
                               enabled: true,
                               mode: 'pages',
                               perPage: 10
                             }"
                                    :search-options="{
                                enabled: true,
                                placeholder: 'Search this table',
                              }">
                                <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'statu'">
                                    <span v-if="props.row.status == 0" class="badge badge-danger">out of stock</span>
                                    <span v-if="props.row.status == 1" class="badge badge-success">in stock</span>
                                </span>
                                    <span v-else-if="props.column.field == 'action'">
                                    <router-link :to="{path: '/allProducts/' + props.row.uniqueId}">
                                        <button type="button" class="btn btn-sm btn-primary btn-circle"
                                        >
                                    <i class="fas fa-eye"></i>
                                </button>
                                </router-link>
                                <button v-if="props.row.disabled == 'enabled'" type="button" class="m-1 btn btn-danger btn-sm btn-circle"
                                        @click="deleteProduct(props.row.id)">
                                    <i class="fas fa-times"></i>
                                </button>
                                        <button v-if="props.row.disabled == 'disabled'" type="button" class="m-1 btn btn-success btn-sm btn-circle"
                                                @click="enableProduct(props.row.id)">
                                    <i class="fas fa-check"></i>
                                </button>
                                </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
<script>

    export default {
        name: 'AllProducts',
        components: {},
        data() {
            return {
                columns: [
                    {
                        label: 'Id#',
                        field: 'uniqueId',
                    },
                    {
                        label: 'Title',
                        field: 'title',
                    },
                    {
                        label: 'Price(Ksh)',
                        field: 'price',
                    },
                    {
                        label: 'Category',
                        field: 'category.name',
                    },
                    {
                        label: 'SubCategory',
                        field: 'subcategory.name',
                    },
                    {
                        label: 'Status',
                        field: 'statu',
                    },
                    {
                        label: 'Show',
                        field: 'disabled',
                    },
                    {
                        label: 'Action',
                        field: 'action'
                    }
                ],
                products: []
            }
        },
        computed:{
            disabled(){
                return this.products.filter(m => m.disabled === 'disabled')
            },
            outOfStock(){
                return this.products.filter(m => m.status === 0)
            },
            inStock(){
                return this.products.filter(m => m.status === 1)
            }
        },
        methods: {
            enableProduct(id) {
                this.$swal.fire({
                    title: 'Enable this Product?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, enable it!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/shopLocal/activate-product/" + id).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Product enabled successfully',
                                'success'
                            )
                            this.allProducts();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            deleteProduct(id) {
                this.$swal.fire({
                    title: 'Disable this Product?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, disable it!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.delete("/admin/shopLocal/delete-product/" + id).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Product disabled successfully',
                                'success'
                            )
                            this.allProducts();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            allProducts() {
                try {
                    this.axios.get("/admin/shopLocal/all-products").then(({data}) => ([this.products = data]));
                } catch (e) {
                    throw new Error(e);
                }
            }
        },
        created() {
            this.allProducts();
        }

    };
</script>
<style></style>
